import { ReprintListItemResponse } from '@/types/service-response'

export class ProjectReprintList {
  public constructor (
    readonly id: number,
    readonly belegId: number,
    readonly name: string,
    readonly formular: string
  ) {}

  static createFromResponse (responseData: ReprintListItemResponse[]): Array<ProjectReprintList> {
    let result: Array<ProjectReprintList> = []
    if (responseData) {
      result = responseData.map((item: ReprintListItemResponse) => {
        return new ProjectReprintList(
          item.ID,
          item.BelegId,
          item.Name ? item.Name : '',
          item.Formular ? item.Formular : ''
        )
      })
    }
    return result
  }
}
